module.exports = __webpack_public_path__ + "img/tamago-bento.92c07115.png";